import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'plural' })
export class PluralPipe implements PipeTransform {
  transform(string: string, count: number) {

    if (count === 1) {
      return string;
    }
    return string + 's';
  }
}
